(() => {
  'use strict';
  if (window.__littleRoarCartDisplayV14) return;
  window.__littleRoarCartDisplayV14 = true;
  if (window.location.pathname.replace(/\/$/, '') !== '/cart') return;

  let busy = false;
  let timer;

  const money = (cents, currency) => new Intl.NumberFormat(document.documentElement.lang || undefined, {
    style: 'currency',
    currency: currency || 'USD'
  }).format(Number(cents || 0) / 100);

  const apply = async () => {
    if (busy) return;
    busy = true;
    try {
      const response = await fetch('/cart.js', { cache: 'no-store', credentials: 'same-origin', headers: { Accept: 'application/json' } });
      if (!response.ok) return;
      const cart = await response.json();
      const items = new Map();
      let roarDiscount = 0;
      let originalSubtotal = 0;

      (cart.items || []).forEach((item) => {
        items.set(item.key, item);
        originalSubtotal += Number(item.original_line_price || 0);
        (item.line_level_discount_allocations || []).forEach((allocation) => {
          const title = allocation?.discount_application?.title || '';
          if (/roar pack/i.test(title)) roarDiscount += Number(allocation.amount || 0);
        });
      });

      document.querySelectorAll('#cart-form .cart-items__table-row[data-key]').forEach((row) => {
        const item = items.get(row.dataset.key);
        if (!item) return;
        const hasRoarPack = (item.line_level_discount_allocations || []).some((allocation) =>
          /roar pack/i.test(allocation?.discount_application?.title || '')
        );
        if (!hasRoarPack) return;

        const unit = row.querySelector('.cart-items__unit-price-wrapper > div');
        const unitText = money(item.original_price, cart.currency);
        if (unit && unit.textContent.trim() !== unitText) unit.innerHTML = `<span>${unitText}</span>`;

        const line = row.querySelector('.cart-items__price text-component');
        const lineText = money(item.original_line_price, cart.currency);
        if (line && line.textContent.trim() !== lineText) {
          line.textContent = lineText;
          line.setAttribute('value', lineText);
        }

        row.querySelectorAll('.cart-items__variants-wrapper li').forEach((li) => {
          if (/roar pack/i.test(li.textContent || '') && li.textContent.trim() !== 'Roar Pack Offer') {
            li.textContent = 'Roar Pack Offer';
          }
        });
      });

      if (roarDiscount > 0) {
        const totals = Array.from(document.querySelectorAll('.cart-totals')).find((el) => !el.closest('.cart-drawer'));
        const container = totals?.querySelector('.cart-totals__original-container');
        if (container) {
          let subtotalRow = container.querySelector('.cart-totals__original');
          if (!subtotalRow) {
            subtotalRow = document.createElement('span');
            subtotalRow.className = 'cart-totals__item cart-totals__original';
            subtotalRow.innerHTML = '<span class="cart-totals__original-label">Subtotal</span><span class="cart-totals__original-value cart-secondary-typography"></span>';
            container.prepend(subtotalRow);
          }
          const subtotalValue = subtotalRow.querySelector('.cart-totals__original-value');
          if (subtotalValue) subtotalValue.textContent = money(originalSubtotal, cart.currency);

          let list = container.querySelector('.cart-discounts');
          if (!list) {
            list = document.createElement('ul');
            list.className = 'cart-discounts';
            list.setAttribute('role', 'list');
            container.append(list);
          }
          let packRow = list.querySelector('[data-lr-roar-pack-offer]');
          if (!packRow) {
            packRow = document.createElement('li');
            packRow.className = 'cart-discounts__item';
            packRow.setAttribute('data-lr-roar-pack-offer', '');
            packRow.innerHTML = '<span class="cart-discounts__label">Roar Pack Offer</span><span class="cart-discounts__value cart-secondary-typography"></span>';
            list.prepend(packRow);
          }
          packRow.querySelector('.cart-discounts__label').textContent = 'Roar Pack Offer';
          packRow.querySelector('.cart-discounts__value').textContent = `-${money(roarDiscount, cart.currency)}`;
        }
      }
    } catch (error) {
      console.warn('[Little Roar] Cart display update failed.', error);
    } finally {
      busy = false;
    }
  };

  const schedule = () => {
    clearTimeout(timer);
    timer = setTimeout(apply, 120);
  };

  apply();
  const root = document.querySelector('main') || document.body;
  new MutationObserver(schedule).observe(root, { childList: true, subtree: true });
})();
